import {
  MESSAGE_CREATE_REQUEST,
  MESSAGE_CREATE_SUCCESS,
  MESSAGE_CREATE_FAIL,
  MESSAGE_MY_LIST_REQUEST,
  MESSAGE_MY_LIST_SUCCESS,
  MESSAGE_MY_LIST_FAIL,
  MESSAGE_DELETE_REQUEST,
  MESSAGE_DELETE_SUCCESS,
  MESSAGE_DELETE_FAIL,
  MESSAGE_REPLY_REQUEST,
  MESSAGE_REPLY_SUCCESS,
  MESSAGE_REPLY_FAIL,
} from "../Constants/MessageConstants";
import URL from "../Url";
import { logout } from "./userActions";

// Create new message
export const createMessage = (subject, message, priority) => async (dispatch, getState) => {
  try {
    dispatch({ type: MESSAGE_CREATE_REQUEST });

    const { userLogin: { userInfo } } = getState();

    const res = await fetch(`${URL}/api/messages`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
      body: JSON.stringify({ subject, message, priority }),
    });

    const data = await res.json();

    if (!res.ok) throw new Error(data?.message || "Failed to create message");

    dispatch({ type: MESSAGE_CREATE_SUCCESS, payload: data });
  } catch (error) {
    if (error.message === "Not authorized, token failed") dispatch(logout());
    dispatch({ type: MESSAGE_CREATE_FAIL, payload: error.message });
  }
};

// Get my messages
export const listMyMessages = () => async (dispatch, getState) => {
  try {
    dispatch({ type: MESSAGE_MY_LIST_REQUEST });

    const { userLogin: { userInfo } } = getState();

    const res = await fetch(`${URL}/api/messages/my-messages`, {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    });

    const data = await res.json();

    if (!res.ok) throw new Error(data?.message || "Failed to fetch messages");

    dispatch({ type: MESSAGE_MY_LIST_SUCCESS, payload: data.messages });
  } catch (error) {
    if (error.message === "Not authorized, token failed") dispatch(logout());
    dispatch({ type: MESSAGE_MY_LIST_FAIL, payload: error.message });
  }
};

// Hide message from client inbox (soft delete)
export const deleteMessage = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: MESSAGE_DELETE_REQUEST });

    const { userLogin: { userInfo } } = getState();

    const res = await fetch(`${URL}/api/messages/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    });

    const data = await res.json();

    if (!res.ok) throw new Error(data?.message || "Failed to delete message");

    dispatch({ type: MESSAGE_DELETE_SUCCESS });
  } catch (error) {
    dispatch({ type: MESSAGE_DELETE_FAIL, payload: error.message });
  }
};

// Reply to message (Customer)
export const replyToMessage = (id, userReply) => async (dispatch, getState) => {
  try {
    dispatch({ type: MESSAGE_REPLY_REQUEST });

    const { userLogin: { userInfo } } = getState();

    const res = await fetch(`${URL}/api/messages/${id}/user-reply`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
      body: JSON.stringify({ userReply }),
    });

    const data = await res.json();

    if (!res.ok) throw new Error(data?.message || "Failed to send reply");

    dispatch({ type: MESSAGE_REPLY_SUCCESS, payload: data.data });
  } catch (error) {
    dispatch({ type: MESSAGE_REPLY_FAIL, payload: error.message });
  }
};